exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-card {\n    max-width: 400px;\n  }\n  .mat-card-image{\n    margin: 0px 0px 0px 0px;\n  }\n  .isApprove-message{\n      text-align: center;\n      color: #ffffff;\n      font-weight: bold;;\n      background: #b6edba;\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/kyc/kyc-approve-reject.component.css
// module id = ../../../../../src/app/components/pages/kyc/kyc-approve-reject.component.css
// module chunks = main